// extracted by mini-css-extract-plugin
export default {"aboutUs":"aboutUs_aboutUs__cha9R","imageContainer":"aboutUs_imageContainer__Exh9U","textContainer":"aboutUs_textContainer__q0cvb","aboutUsTitle":"aboutUs_aboutUsTitle__I-hoH"};